import { getApiClient } from '@src/services/api-client'
import { MutationFunction, useMutation } from '@tanstack/react-query'
import { LoanCustomer, SearchCustomerDto } from '../../types/LoanCustomerSchema'

const url = '/customers/search'

// Query Keys
export const loanCustomerKeys = {
  all: ['loanCustomer'] as const,
  search: (params: SearchCustomerDto) => [...loanCustomerKeys.all, 'search', params] as const,
}

// API Functions
export async function findCustomers(data: SearchCustomerDto): Promise<LoanCustomer[]> {
  const apiClient = getApiClient()
  const response = await apiClient.post<LoanCustomer[]>(url, data)
  return response.data
}

// React-Query Hooks
export function useFindCustomers(): [MutationFunction<LoanCustomer[], SearchCustomerDto>, boolean] {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: findCustomers,
  })

  return [mutateAsync, isPending]
}

